import {memo} from 'react';

import styled from 'styled-components';

import {BackgroundProps} from '~/shared/components/TenbisCard/type';
import TenbisLogo from '~/assets/images/tenBis-logo.svg?react';

import TenbisLogoGradient from './assets/tenbisLogoGradientBg.svg?react';

const Background = styled.div<{isActive?: boolean}>`
  position: absolute;
  display: flex;
  justify-content: center;
  padding-top: 15.8%;
  inset: 0;
  background-color: ${({theme, isActive}) => (!isActive ? 'rgba(140, 153, 155, 0.50)' : theme.colors.contentBrandNew)};
  z-index: 1;
`;

const StyledTenbisLogo = styled(TenbisLogo)`
  position: absolute;
  top: 20px;
  left: 20px;

  g {
    fill: ${({theme}) => theme.colors.surface};
  }
`;

const StyledTenbisLogoGradient = styled(TenbisLogoGradient)`
  position: absolute;
  bottom: 0;
  right: 0;
`;

const WalleBackground = ({isActive}: BackgroundProps) => {
  return (
    <Background isActive={isActive}>
      <StyledTenbisLogo />
      <StyledTenbisLogoGradient />
    </Background>
  );
};

export default memo(WalleBackground);
